var _rect, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#FAF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 9.58334H36.0002C37.3348 9.58352 38.4163 10.6658 38.4163 12.0003V17.3333C38.4163 18.6679 37.3348 19.7502 36.0002 19.7503H19.7502V36.0003C19.7501 37.3349 18.6678 38.4164 17.3333 38.4164H12.0002C10.6657 38.4164 9.58343 37.3349 9.58325 36.0003V12.0003C9.58325 10.6656 10.6656 9.58334 12.0002 9.58334ZM13.3333 11.7503C12.4588 11.7503 11.7502 12.4589 11.7502 13.3333V34.6664C11.7502 35.5408 12.4588 36.2503 13.3333 36.2503H16.0002C16.8745 36.2502 17.5833 35.5407 17.5833 34.6664V33.0833H16.0002C15.402 33.0833 14.9164 32.5985 14.9163 32.0003C14.9163 31.402 15.4019 30.9164 16.0002 30.9164H17.5833V26.4164H16.0002C15.4019 26.4164 14.9163 25.9317 14.9163 25.3333C14.9163 24.735 15.4019 24.2503 16.0002 24.2503H17.5833V19.7503H16.0002C15.4019 19.7503 14.9163 19.2647 14.9163 18.6664C14.9164 18.0682 15.4021 17.5833 16.0002 17.5833H17.5833V16.0003C17.5833 15.4021 18.0681 14.9165 18.6663 14.9164C19.2646 14.9164 19.7502 15.402 19.7502 16.0003V17.5833H24.2502V16.0003C24.2502 15.402 24.7349 14.9164 25.3333 14.9164C25.9316 14.9164 26.4163 15.402 26.4163 16.0003V17.5833H30.9163V16.0003C30.9163 15.402 31.4019 14.9164 32.0002 14.9164C32.5984 14.9165 33.0833 15.4021 33.0833 16.0003V17.5833H34.6663C35.5406 17.5833 36.2501 16.8746 36.2502 16.0003V13.3333C36.2502 12.4589 35.5407 11.7503 34.6663 11.7503H13.3333Z",
    fill: "#9538EB",
    stroke: "#FAF5FF",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaIcon);
export default __webpack_public_path__ + "static/media/areaIcon.72af8f3a794154088c87d491aae3b2a4.svg";
export { ForwardRef as ReactComponent };